// extracted by mini-css-extract-plugin
export default {"link":"Link_link__rRpky","icon":"Link_icon__2-3Hd"};